import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function RequestOTP() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleOtpSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);
      const response = await axios.post("/super-admin/reset-password/otp", {
        email,
      });

      if (response.data.type === "success") {
        navigate("/input-otp", { state: { email } });
        alert("OTP has been sent successfully, check your mail");
      } else {
        alert("Failed to send OTP. Please try again later.");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        alert(error.response.data.message);
      } else {
        alert("Failed to send OTP. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-container">
      <div className="otp-input">
        <div className="otp-input-main container">
          <h1>OTP Request</h1>
          <p>Enter your registered email address to request for OTP</p>
          <form className="otp-form" onSubmit={handleOtpSubmit}>
            <div className="form-group">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>
            <button type="submit" className="otp-button" disabled={loading}>
              {loading ? "Sending OTP..." : "Request OTP"}
            </button>
          </form>
        </div>
      </div>

      <div className="login-image2"></div>
    </div>
  );
}

export default RequestOTP;
